import React from "react";
import TextInput from "./TextInput";
import FixButton from "./Button";
import AddRata from "./AddRataWidget";
import RataStatusWidget from "./RataStatusWidget";
import moment from "moment";
import { red } from "@material-ui/core/colors";
import addRataStatus from "../services/addRataStatus";
import Cookies from "universal-cookie";
import getRataStatus from "../services/getRataStatus";

export default class GestioneRateWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      costo: 0,
      showAddRata: false,
      custom: this.props.custom,
      piano: this.props.piano,
      isLoading: true,
    };
  }

  async reload() {
    if (this.props.isStudent == false) return;

    const studentId = this.props.studentObj.id;
    const corsoId = this.props.corso.id;

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.rataStatus = await getRataStatus(username, token, corsoId, studentId);

    this.setState({ status: this.rataStatus, isLoading: false });
  }

  aggiungiRata() {
    this.setState({ showAddRata: true });
  }

  async componentDidMount() {
    await this.reload();
  }

  salva() {
    if (this.state.piano == undefined || this.state.piano.costo == undefined) {
      alert("Errore nel campo COSTO");
      return;
    }

    var costo = parseFloat(this.state.piano.costo);
    if (isNaN(costo)) {
      alert("Errore nel campo COSTO");
      return;
    }

    var datesList = [];
    if (this.state.piano.rate)
      for (var r of this.state.piano.rate) {
        if (datesList.indexOf(r.data) == -1) datesList.push(r.data);
        else {
          alert("Imposibile inserire più date nello stesso giorno");
          return;
        }
      }

    var importoTot = 0;
    if (this.state.piano.rate)
      for (var r of this.state.piano.rate) {
        importoTot += parseFloat(r.importo);
      }

    if (importoTot != costo) {
      alert("Il totale delle rate deve essere uguale al costo");
      return;
    }

    var error = false;
    for (var i = 1; i < this.state.piano.rate.length; i++) {
      const r1 = this.state.piano.rate[i - 1];
      const r2 = this.state.piano.rate[i];
      if (r1.data == r2.data) error = true;
    }

    if (error == true) {
      alert("Non possono esserci due rate con la stessa data");
      return;
    }

    this.props.onSalva(
      this.state.piano.costo,
      this.state.piano.rate ? this.state.piano.rate : [],
      this.rataStatus
    );
  }

  render() {
    if (this.state.isLoading) {
      return <div />;
    } else {
      var detailString = undefined;
      if (this.state.piano != undefined && this.state.piano.rate != undefined) {
        var importoPagato = 0;
        var importoDaPagare = 0;
        for (var rata of this.state.piano.rate) {
          var rataDetails =
            this.rataStatus == undefined
              ? undefined
              : this.rataStatus.find(
                  (r) =>
                    r.data == rata.data &&
                    parseFloat(r.importo.replace(/€/g, "")) ==
                      parseFloat(rata.importo.replace(/€/g, ""))
                );
          var status =
            rataDetails != undefined ? rataDetails.status : "NON PAGATA";
          var importo = rata.importo;

          if (status == "PAGATA") importoPagato += parseInt(importo);
          else importoDaPagare += parseInt(importo);
        }

        detailString =
          "Pagato: " + importoPagato + " - Da pagare: " + importoDaPagare;
      }

      return (
        <div
          style={{
            border: "1px solid black",
            padding: "10px",
            marginBottom: "20px",
          }}
        >
          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
            {detailString}
          </div>

          {this.props.compactMode != true && (
            <TextInput
              name={"Costo"}
              value={this.state.piano != undefined ? this.state.piano.costo : 0}
              onChange={(text) => {
                this.setState((prevState) => ({
                  piano: {
                    ...prevState.piano,
                    costo: text,
                  },
                }));
              }}
            />
          )}

          {this.props.compactMode != true && (
            <FixButton
              title={"Aggiungi rata"}
              callback={this.aggiungiRata.bind(this)}
            />
          )}

          {this.state.piano &&
            this.state.piano.rate &&
            this.state.piano.rate.map((rata, index) => {
              // Funzione per normalizzare le date per il confronto
              const normalizeDate = (dateStr) => {
                if (!dateStr) return "";
                // Prova diversi formati e restituisce sempre DD-MM-YYYY
                let momentDate = moment(dateStr, "DD-MM-YYYY");
                if (!momentDate.isValid()) {
                  momentDate = moment(dateStr, "DD-MMM-YYYY");
                }
                if (!momentDate.isValid()) {
                  momentDate = moment(dateStr);
                }
                return momentDate.isValid()
                  ? momentDate.format("DD-MM-YYYY")
                  : dateStr;
              };

              var rataDetails =
                this.rataStatus == undefined
                  ? undefined
                  : this.rataStatus.find((r) => {
                      const dataMatch =
                        normalizeDate(r.data) === normalizeDate(rata.data);
                      const importoMatch =
                        parseFloat(r.importo.replace(/€/g, "")) ===
                        parseFloat(rata.importo.replace(/€/g, ""));
                      return dataMatch && importoMatch;
                    });

              // DEBUG: Log per il matching
              // console.log(`Matching rata ${index}:`, {
              //   rataPiano: { data: rata.data, importo: rata.importo },
              //   rataStatus: this.rataStatus ? this.rataStatus.filter(r =>
              //     parseFloat(r.importo.replace(/€/g, "")) == parseFloat(rata.importo.replace(/€/g, ""))
              //   ) : [],
              //   rataDetails: rataDetails
              // });

              var status =
                rataDetails != undefined ? rataDetails.status : "NON PAGATA";
              // console.log("status", status);

              return (
                <div
                  style={{
                    padding: "5px",
                    border: "1px solid #888888",
                    marginBottom: "10px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    onClick={async () => {
                      if (this.props.compactMode) return;

                      const rataObj = {
                        studente: this.props.studentObj,
                        data: rata.data,
                        importo: rata.importo,
                        corso: this.props.corso,
                        files: rataDetails ? rataDetails.files : undefined,
                        note: rataDetails ? rataDetails.note : undefined,
                      };

                      console.log(
                        "GestioneRateWidget - Aprendo RataStatusWidget con:",
                        rataObj
                      );

                      this.setState({
                        rataStatusWidgetVisible: true,
                        status: status,
                        rataIndex: index,
                        rata: rataObj,
                      });
                      //                        this.reload();
                    }}
                    style={{ flex: 1 }}
                  >
                    <div style={{ fontSize: "16px" }}>Data: {rata.data}</div>
                    <div style={{ fontSize: "16px" }}>
                      Importo: {rata.importo + "€"}
                    </div>
                    {this.props.isStudent ? (
                      <div style={{ fontSize: "16px" }}>
                        Stato:{" "}
                        <span
                          style={{
                            color:
                              status === "PAGATA"
                                ? "green"
                                : status === "DA VERIFICARE"
                                ? "#e77708"
                                : status === "NON PAGATA"
                                ? "#c50000"
                                : "black",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {status}
                        </span>
                      </div>
                    ) : null}
                    {rataDetails != undefined &&
                    rataDetails.note != undefined &&
                    rataDetails.note != "" ? (
                      <div style={{ fontSize: "16px" }}>
                        Note: {rataDetails.note}
                      </div>
                    ) : null}
                  </div>

                  {this.props.compactMode != true && (
                    <div
                      style={{
                        color: "#ff0000",
                        cursor: "pointer",
                        marginLeft: "15px",
                        flexShrink: 0,
                      }}
                      onClick={() => {
                        if (window.confirm("Eliminare la rata?") == false)
                          return;
                        if (status == "PAGATA") {
                          alert("Impossibile eliminare una rata già pagata");
                          return;
                        }
                        var piano = this.state.piano;
                        piano.rate.splice(index, 1);
                        this.setState({ piano: piano });
                      }}
                    >
                      Cancella
                    </div>
                  )}
                </div>
              );
            })}

          {this.props.compactMode != true && (
            <FixButton
              title={"Aggiorna piano rate"}
              callback={this.salva.bind(this)}
            />
          )}

          <RataStatusWidget
            show={this.state.rataStatusWidgetVisible}
            rata={this.state.rata}
            status={this.state.status}
            isStudent={this.props.isStudent}
            onClose={(rata) => {
              this.setState({ rataStatusWidgetVisible: false });
              if (rata == undefined) return;

              var newRata = {
                data: rata.data,
                importo: rata.importo,
              };
              //   this.rataStatus[this.state.rataIndex] = rata;
              var piano = this.state.piano;
              var oldData = piano.rate[this.state.rataIndex].data;
              var oldImporto = piano.rate[this.state.rataIndex].importo;
              piano.rate[this.state.rataIndex] = newRata;

              console.log("Updating rataStatus with saved rata:", rata);

              // Funzione per normalizzare le date (stessa del matching)
              const normalizeDate = (dateStr) => {
                if (!dateStr) return "";
                let momentDate = moment(dateStr, "DD-MM-YYYY");
                if (!momentDate.isValid()) {
                  momentDate = moment(dateStr, "DD-MMM-YYYY");
                }
                if (!momentDate.isValid()) {
                  momentDate = moment(dateStr);
                }
                return momentDate.isValid()
                  ? momentDate.format("DD-MM-YYYY")
                  : dateStr;
              };

              var currentRata = null;
              for (var i = 0; i < this.rataStatus.length; i++) {
                var s = this.rataStatus[i];

                // Usiamo la stessa logica di normalizzazione per trovare la rata
                const dataMatch =
                  normalizeDate(s.data) === normalizeDate(oldData);
                const importoMatch =
                  parseFloat(s.importo) === parseFloat(oldImporto);

                if (!dataMatch || !importoMatch) continue;

                currentRata = s;
                s.data = normalizeDate(rata.data); // Normalizziamo anche la nuova data
                s.importo = rata.importo;
                s.status = rata.status;
                s.files = rata.files;
                s.note = rata.note;
                this.rataStatus[i] = s;
                console.log("Updated rataStatus item:", s);
                break;
              }

              if (currentRata == null) {
                // Se non abbiamo trovato la rata esistente, aggiungiamola con la data normalizzata
                const newRataStatus = {
                  ...rata,
                  data: normalizeDate(rata.data),
                };
                this.rataStatus.push(newRataStatus);
                console.log("Added new rataStatus item:", newRataStatus);
              }

              // Solo se il salvataggio non ha avuto successo, chiamiamo onModification
              if (!rata.saved) {
                this.props.onModification && this.props.onModification();
              } else {
                // Se il salvataggio ha avuto successo, chiamiamo onRataSalvata se disponibile
                this.props.onRataSalvata && this.props.onRataSalvata();
              }

              this.setState({ piano: piano });

              //                this.reload();
            }}
          />

          <AddRata
            show={this.state.showAddRata}
            onClose={() => {
              this.setState({ showAddRata: false });
            }}
            isStudent={this.props.isStudent}
            onFinish={(data, rata, status, mese) => {
              var rate = [];

              if (this.state.piano != undefined) rate = this.state.piano.rate;
              if (rate == undefined) rate = [];

              rate.push({
                data: data,
                importo: rata,
                mese: mese, // AGGIUNTO
              });

              this.rataStatus &&
                this.rataStatus.push({
                  id_corso: this.props.corso.id,
                  id_studente: this.props.studentObj.id,
                  importo: rata,
                  data: data,
                  note: "",
                  files: "",
                  status: status,
                });

              rate = rate.sort((l1, l2) => {
                var ll1 = moment(l1.data, "DD-MM-yyyy");
                var ll2 = moment(l2.data, "DD-MM-yyyy");
                return ll1 - ll2;
              });

              this.props.onModification && this.props.onModification();

              this.setState({ showAddRata: false });
              this.setState((prevState) => ({
                piano: {
                  ...prevState.piano,
                  rate: rate,
                },
              }));
            }}
            // Nuova callback per gestire multiple rate
            onFinishMultiple={(rateGenerate) => {
              var rate = [];

              if (this.state.piano != undefined) rate = this.state.piano.rate;
              if (rate == undefined) rate = [];

              // Aggiungi tutte le rate generate
              rateGenerate.forEach((rataGenerata) => {
                rate.push({
                  data: rataGenerata.data,
                  importo: rataGenerata.importo,
                  mese: rataGenerata.mese,
                });

                this.rataStatus &&
                  this.rataStatus.push({
                    id_corso: this.props.corso.id,
                    id_studente: this.props.studentObj.id,
                    importo: rataGenerata.importo,
                    data: rataGenerata.data,
                    note: "",
                    files: "",
                    status: rataGenerata.status,
                  });
              });

              rate = rate.sort((l1, l2) => {
                var ll1 = moment(l1.data, "DD-MM-yyyy");
                var ll2 = moment(l2.data, "DD-MM-yyyy");
                return ll1 - ll2;
              });

              this.props.onModification && this.props.onModification();

              this.setState({ showAddRata: false });
              this.setState((prevState) => ({
                piano: {
                  ...prevState.piano,
                  rate: rate,
                },
              }));
            }}
          />
        </div>
      );
    }
  }
}
